import React, { Fragment, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  getAgrupacionCondiciones,
  getAgrupacionHijos,
  limpiarClavesSeleccionadas,
  limpiarHijoSeleccionado,
  setClaveSeleccionada,
  setHijoSeleccionado,
} from '../../../actions/agrupaciones'
import { cargarParametros } from '../../../helpers/funciones'
import i18n from '../../../lang/idiomas'
import AnadirCarrito from '../AnadirCarrito'
import Precio from '../Precio'
import Presentaciones from './Presentaciones'

let parametros_usados = ['mostrar_iva', 'tipo_precio', 'mostrar_pres', 'estilo_precio']
let parametros

const AgrupacionFiltros = props => {
  const dispatch = useDispatch()

  const portal = useSelector(state => state.portal.portal)
  const articulo = useSelector(state => state.articulo.articulo)
  const hijos = useSelector(state => state.agrupaciones.hijos)
  const condiciones = useSelector(state => state.agrupaciones.condiciones)
  const claves_seleccionadas = useSelector(state => state.agrupaciones.claves_seleccionadas)
  const hijo_seleccionado = useSelector(state => state.agrupaciones.hijo_seleccionado)

  useEffect(() => {
    dispatch(getAgrupacionHijos(props.codigo_articulo))
    dispatch(getAgrupacionCondiciones(props.codigo_articulo))
    dispatch(limpiarClavesSeleccionadas())
    dispatch(limpiarHijoSeleccionado())
  }, [])

  useEffect(() => {
    window.wookie()
  })

  const onClick = e => {
    if (e.target.value && e.target.value !== '') {
      dispatch(limpiarHijoSeleccionado())
      dispatch(
        setClaveSeleccionada({
          clave: e.target.name,
          valor_clave: e.target.value,
        }),
      )
    }
  }

  const seleccionHijo = e => {
    if (e.target.value && e.target.value !== '') {
      let hijo = hijos.filter(hijo => hijo.codigo_articulo === e.target.value)

      if (hijo) {
        dispatch(setHijoSeleccionado(hijo[0]))
      }
    }
  }

  const filtrar_hijos = () => {
    const hijos_filtrados = hijos.filter(hijo => {
      return hijo.claves.every(clave => {
        let clave_aplicada = claves_seleccionadas.filter(
          cla => cla.clave === clave.clave && cla.valor_clave === clave.valor_clave,
        )

        return !!(clave_aplicada && clave_aplicada.length > 0)
      })
    })

    return hijos_filtrados
  }

  parametros = cargarParametros(parametros_usados, portal.parametros_ecom, 'AGFIL')
  const hijos_filtrados = filtrar_hijos()
  return (
    <div className='agrupacion_articulos'>
      {condiciones.map(condicion => (
        <div
          key={condicion.id}
          className='condicion_agrupacion'>
          <div className='titulo_agrupacion'>{condicion.clave.nombre}</div>
          {condicion.valores
            .filter(valor => {
              return hijos.some(hijo => {
                return hijo.claves.some(clave_hijo => valor.valor_clave === clave_hijo.valor_clave)
              })
            })
            .map(valor => {
              return (
                <button
                  key={valor.id}
                  className={
                    claves_seleccionadas.find(
                      cla => cla.clave === valor.clave && cla.valor_clave === valor.valor_clave,
                    )
                      ? 'btn btn-small btn-primary'
                      : 'btn btn-small btn-border'
                  }
                  name={valor.clave}
                  value={valor.valor_clave}
                  onClick={onClick}>
                  {valor.nombre}
                </button>
              )
            })}
        </div>
      ))}
      {Object.keys(condiciones).length === Object.keys(claves_seleccionadas).length ? (
        hijos_filtrados.length > 0 ? (
          <Fragment>
            <div className='tabla_agrupacion'>
              <div className='col-12'>
                <div className='row titulo_agrupacion_fila'>
                  <h5>{i18n.t('eparciales.epseluar')}</h5>
                </div>
                {hijos_filtrados.map(hijo => (
                  <div
                    key={hijo.id}
                    className='row tabla_agrupacion_fila'>
                    <div
                      className=' col-sm-6 col-md-4 col-lg-4 tabla_agrupacion_columna columna_descripcion'
                      style={{ heigth: '100%' }}>
                      <div className='descrip-articulo-hijo-cont'>
                        <span className='descrip-articulo-hijo'>{hijo.descrip_comercial}</span>
                      </div>
                    </div>

                    {hijo_seleccionado.codigo_articulo === hijo.codigo_articulo ? (
                      <Fragment>
                        <div className='col-sm-6 col-md-2 col-lg-2 tabla_agrupacion_columna columna_precio'>
                          <div className='tt-price'>
                            <Precio
                              codigo_articulo={
                                hijo_seleccionado?.codigo_articulo || articulo.codigo_articulo
                              }
                              presentacion={
                                hijo_seleccionado?.presentacion_web || articulo.presentacion_web
                              }
                              mostrar_iva={parametros.mostrar_iva}
                              mostrar_pres={parametros.mostrar_pres}
                              estilo_precio={parametros.estilo_precio}
                              tipo_precio={parametros.tipo_precio}
                              forzar_peticion='S'
                            />
                          </div>
                        </div>

                        <div className=' col-sm-12 col-md-12 col-lg-12 tabla_agrupacion_columna columna_botonera'>
                          {hijo_seleccionado && hijo_seleccionado !== '' ? (
                            <>
                              <Presentaciones
                                articulo={hijo_seleccionado.codigo_articulo}
                                presentacion_defectiva={hijo_seleccionado.presentacion_web}
                              />
                              <AnadirCarrito
                                articulo={hijo_seleccionado}
                                mostrar_texto_btn='S'
                                origen='ficha'
                              />
                            </>
                          ) : (
                            ''
                          )}
                        </div>
                      </Fragment>
                    ) : (
                      <div className='col-sm-6 col-md-4 col-lg-4 tabla_agrupacion_columna columna_descripcion'>
                        <button
                          onClick={seleccionHijo}
                          value={hijo.codigo_articulo}
                          className={
                            hijo_seleccionado.codigo_articulo === hijo.codigo_articulo
                              ? 'btn btn-small btn-primary'
                              : 'btn btn-small btn-border'
                          }>
                          {hijo_seleccionado.codigo_articulo === hijo.codigo_articulo
                            ? i18n.t('eparciales.epseldo')
                            : i18n.t('eparciales.epselar')}
                        </button>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </Fragment>
        ) : (
          i18n.t('eparciales.epnsenar')
        )
      ) : (
        i18n.t('eparciales.epuselco')
      )}
    </div>
  )
}

export default AgrupacionFiltros
